<div class="onboarding">
    <div class="semi-background">
        <div class="col-md-10 mx-auto">
            
            <onboarding-header [step]="step"></onboarding-header>

            @if(team){
                <div class="content mt-0 mt-md-3">
                    <div class="animate__animated animate__slideInRight">
                        <div class="form-group title mt-4">
                            <h4 class="text-center">{{ 'onboarding.your_team.description' | translate}}</h4>
                        </div>
                    
                        <form class="form-horizontal mt-3" name="teamMembersForm">
                    
                            <div class="row">
                                
                                    <h4>{{ 'teamName' | translate}}</h4>
                    
                                    <div class="input-group">
                                        <input type="text" id="teamName" name="teamName" (change)="save_team_name(team.name)" [(ngModel)]="team.name" class="form-control" required>
                                        <span class="icon-addon"><i class="far fa-pen"></i></span>
                                    </div>
                                    @if(teamNameError){
                                        <div class="text-danger">{{'error.team_name_required' | translate}}</div>
                                    }
                                
                            </div>
                        </form>
                    
                        <div class="mt-4 d-block text-center btn-group" role="group">
                            <button class="btn btn-primary px-4 mb-1 align-top" (click)="createTeamMember()" data-cy="add-teammember" title="{{'create_teammember' | translate}}">
                                <span class="add-member-btn"><i class="far fa-plus"></i> {{('create_teammember' | translate)}}</span>
                            </button>

                            <button class="btn btn-default px-4 mb-1 align-top" (click)="openBatchImportDialog()" title="{{ 'batch_import_users' | translate}}">
                                <i class="far fa-file-"></i> {{'batch_import_users' | translate}}
                            </button>
                        </div>

                        <div class="row mt-4">
                            <h4>{{ 'teamMembers' | translate}}</h4>

                            <team-members-list [team]="team" 
                                                [members]="teammembers" 
                                                [selectionEnabled]="false" 
                                                [moveEnabled]="false" 
                                                (onMemberChanged)="memberChanged()"></team-members-list>
                        </div>
                
                        <div class="form-group form-actions row mt-4">
                            <div class="col-md-8"></div>
                            <div class="col-md-2">
                                <button class="btn btn-primary btn-lg btn-next" data-cy="next-btn" [disabled]="teamNameError" (click)="next()">
                                    {{'next' | translate}} <i class="far fa-arrow-right"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            
        </div>
    </div>
</div>